import { AxiosResponse } from 'axios'
import firebase from 'firebase/compat/app'
import { RemoteConfig } from 'firebase/remote-config'
import { createContext } from 'react'

import { GetVariableValue } from '../hooks'
import { AnyVariable, InputParameter, VariableSource } from '../utils'

export type FP = (getVariableValue: GetVariableValue, parameters: InputParameter[]) => Promise<void>

export type FV = (getVariableValue: GetVariableValue, variable: AnyVariable) => Promise<void>

export type FD = (name: string, data?: { [key: string]: any }) => Promise<AxiosResponse<any, any>>

export type FPVT = (
  getVariableValue: GetVariableValue,
  parameters: InputParameter[],
  valueTarget: VariableSource
) => Promise<void>

export type FF = (getVariableValue: GetVariableValue, file: File) => Promise<unknown>

export interface F {
  firestorePrefix: string
  auth: firebase.auth.Auth
  firestore: firebase.firestore.Firestore
  remoteConfig: RemoteConfig
  getRemoteConfigValue: (key: string) => string
  signInWithGoogle: () => Promise<void>
  createUserWithEmailAndPassword: FP
  signInWithEmailAndPassword: FP
  sendPasswordResetEmail: FV
  sendSignInLinkToEmail: FV
  reSendSignInLinkToEmail: FV
  checkNotificationsEnabled: () => Promise<boolean>
  enableNotifications: () => Promise<void>
  logout: () => Promise<void>
  runFlow: FD
  search: (url: string) => Promise<AxiosResponse<any, any>>
  oauth: FPVT
  checkoutSelected: (priceId: string) => Promise<unknown>
  getAssetRecord: FF
  emailKey: string
}

export const FirebaseContext = createContext<{ f: F }>({
  f: {
    firestorePrefix: '',
    auth: {} as firebase.auth.Auth,
    firestore: {} as firebase.firestore.Firestore,
    remoteConfig: {} as RemoteConfig,
    getRemoteConfigValue: () => '',
    signInWithGoogle: async () => {},
    createUserWithEmailAndPassword: async () => {},
    signInWithEmailAndPassword: async () => {},
    sendPasswordResetEmail: async () => {},
    sendSignInLinkToEmail: async () => {},
    reSendSignInLinkToEmail: async () => {},
    checkNotificationsEnabled: async () => false,
    enableNotifications: async () => {},
    logout: async () => {},
    runFlow: () => ({}) as Promise<AxiosResponse<any, any>>,
    search: async () => ({}) as Promise<AxiosResponse<any, any>>,
    oauth: async () => {},
    checkoutSelected: async () => {},
    getAssetRecord: async () => {},
    emailKey: '',
  },
})

export * from './FirebaseProvider'
